import { inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import Swal, { SweetAlertOptions } from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class SweetAlertService {
  swalComponent!: SwalComponent;

  swalOptions: SweetAlertOptions = {};

  #translate = inject(TranslateService);

  async swalSuccess(title?: string, text?: string) {
    return new Promise((resolve) => {
      void Swal.fire({
        icon: "success",
        title: this.#valueOrTranslation(title, "SWEETALERT.SUCCESS_TITLE"),
        text: this.#valueOrTranslation(text, "SWEETALERT.SUCCESS_TEXT"),
        showConfirmButton: false,
        heightAuto: false,
        // showClass: {
        //   popup: 'animate__animated animate__fadeInUp',
        // },
        // hideClass: {
        //   popup: 'animate__animated animate__fadeOutDown',
        // },
        timer: 2000,
      }).then((_) => {
        resolve(true);
      });
    });
  }

  async swalAlert(title?: string, text?: string, showConfirmButton = false) {
    return new Promise((resolve) => {
      void Swal.fire({
        icon: "error",
        // style : "danger",
        title: this.#valueOrTranslation(title, "SWEETALERT.ERROR_TITLE"),
        text: this.#valueOrTranslation(text, "SWEETALERT.ERROR_TEXT"),
        showConfirmButton: showConfirmButton,
        heightAuto: false,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-danger danger",
        },
        // showClass: {
        //   popup: "animate__animated animate__fadeInUp",
        // },
        // hideClass: {
        //   popup: "animate__animated animate__fadeOutDown",
        // },
        timer: showConfirmButton ? undefined : 2000,
      }).then((_) => {
        resolve(true);
      });
    });
  }

  async swalWarning(title?: string, text?: string) {
    return new Promise((resolve) => {
      void Swal.fire({
        icon: "warning",
        title: this.#valueOrTranslation(title, "SWEETALERT.WARNING_TITLE"),
        text: this.#valueOrTranslation(text, "SWEETALERT.WARNING_TEXT"),
        showConfirmButton: true,
        heightAuto: false,
        // showClass: {
        //   popup: "animate__animated animate__fadeInUp",
        // },
        // hideClass: {
        //   popup: "animate__animated animate__fadeOutDown",
        // },
        customClass: {
          confirmButton: "btn btn-info",
        },
        confirmButtonText: this.#translate.instant("COMPONENT.CLOSE"),
        didOpen: () => Swal.getConfirmButton()?.blur(),
      }).then((_) => {
        resolve(true);
      });
    });
  }

  async swalConfirmation(
    title?: string,
    text?: string,
    confirmButtonText?: string,
    cancelButtonText?: string
  ) {
    const promise = new Promise((resolve) => {
      void Swal.fire({
        title: this.#valueOrTranslation(
          title,
          "SWEETALERT.CONFIRMATION_TITLE",
        ),
        text: this.#valueOrTranslation(
          text,
          "SWEETALERT.CONFIRMATION_TEXT",
        ),
        icon: "warning",
        showCancelButton: true,
        heightAuto: false,
        reverseButtons: true,

        // showClass: {
        //   popup: "animate__animated animate__fadeInUp",
        // },
        // hideClass: {
        //   popup: "animate__animated animate__fadeOutDown",
        // },
        // showLoaderOnConfirm: true,
        // customClass: {
        //   confirmButton: "btn btn-primary",
        //   cancelButton: "btn",
        // },

        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-primary",
          popup: `min-w-425px`,
          title: "fw-bold mt-4",
          htmlContainer: "mt-1 pt-2 ",
          actions: "mt-3 gap-3 mb-0",
        },
        confirmButtonText: this.#valueOrTranslation(
          confirmButtonText,
          "COMPONENT.CONFIRM",
        ),
        cancelButtonText: this.#valueOrTranslation(
          cancelButtonText,
          "COMPONENT.CANCEL",
        ),
        didOpen: () => Swal.getConfirmButton()?.blur(),
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(true);
        }
      });
    });
    return promise;
  }

  async swalLoading(title?: string, text?: string) {
    return new Promise((resolve) => {
      void Swal.fire({
        // icon: 'error',
        title: this.#valueOrTranslation(title, "SWEETALERT.PROCESSING_TITLE"),
        text: this.#valueOrTranslation(text, "SWEETALERT.PROCESSING_TEXT"),
        showConfirmButton: false,
        heightAuto: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        // showClass: {
        //   popup: 'animate__animated animate__fadeInUp',
        // },
        // hideClass: {
        //   popup: 'animate__animated animate__fadeOutDown',
        // },
        didOpen: () => {
          Swal.showLoading();
        },
        // timer: 2000,
      }).then(
        (_) => {
          resolve(true);
        },
        () => {}
      );
    });
  }

  async swalClose() {
    return new Promise(() => {
      Swal.close();
    });
  }

  #valueOrTranslation(value: string | undefined, translationKey: string) {
    return value !== undefined && value !== ""
      ? value
      : String(this.#translate.instant(translationKey));
  }
}
